import React from 'react';
import { HealthPlanTimelineGroup } from '../../../Models/HealthPlan/HealthPlanTimelineGroup';
import { useAppContext } from '../../../Services/AppContext';
import Text from '../../Base/Text/Text';
// @ts-expect-error
import styles from './PlanTimeline.module.scss';
import PlanTimelineColumn from './PlanTimelineColumn';
import PlanTimelineLegend from './PlanTimelineLegend';

interface PlanTimelineProps {
	data: HealthPlanTimelineGroup[];
	onMonthClick?: (item: HealthPlanTimelineGroup) => void;
	showDetails?: boolean;
	patientId: string;
	healthPlanUser?: any;
	allowEdit?: boolean;
	workplaceId: string;
	reloadData?: any;
}

const PlanTimeline: React.FC<PlanTimelineProps> = ({
	data = [],
	onMonthClick,
	patientId,
	allowEdit = true,
	workplaceId,
	reloadData,
	healthPlanUser,
}) => {
	if (!healthPlanUser) {
		healthPlanUser = useAppContext();
	}

	const handleMonthClick = (item: HealthPlanTimelineGroup) => {
		!!onMonthClick && onMonthClick(item);
	};

	return (
		<div className={styles.wrapper}>
			<div className={'d-flex flex-row justify-content-between'}>
				<PlanTimelineLegend />
			</div>
			<div className={styles.timelineWrapper}>
				<div className={styles.timelinePart}>
					<div className={styles.timeline}>
						{data.map((column, index) => (
							<React.Fragment key={index}>
								<PlanTimelineColumn
									data={column}
									healthPlanUser={healthPlanUser}
									reloadData={reloadData}
									workplaceId={workplaceId}
									patientId={patientId}
									allowEdit={allowEdit}
									onTitleClick={handleMonthClick}
								/>
							</React.Fragment>
						))}
					</div>
				</div>
			</div>
			<Text
				className={styles.description}
				tx={'diabetes.healthPlan.individualize'}
			/>
		</div>
	);
};

export default PlanTimeline;
